import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import { cameraButton, uploadImage } from "../../../assets";

interface EventEHRUploadImageCardProps {
  imageUrl: string | null;
  handleImage: (data: any) => void;
}

const EventEHRUploadImageCard = ({
  imageUrl = null,
  handleImage,
}: EventEHRUploadImageCardProps) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(imageUrl);

  // Handler for dropped files
  const onDrop = (acceptedFiles: File[]) => {
    const file = acceptedFiles[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => setSelectedImage(reader.result as string);
      reader.readAsDataURL(file);
      handleImage(file);
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "image/jpeg": [".jpeg", ".jpg"],
      "image/png": [".png"],
    },
  });
  return (
    <div
      {...getRootProps()}
      className={`flex justify-center items-center flex-col background-F4F4F4 p-3 gap-2 rounded-lg cursor-pointer ${
        isDragActive ? "border-dashed border-2 border-blue-500" : ""
      }`}
    >
      <input {...getInputProps()} />
      <div className="relative inline-block">
        <img
          style={{ width: "90px", height: "90px", borderRadius: "50%" }}
          src={selectedImage || uploadImage}
          alt="upload-preview"
          className="rounded-lg"
        />
        <div className="absolute right-8 bottom-[-14px] transform -translate-y-1/2 translate-x-full">
          <img src={cameraButton} alt="camera-icon" />
        </div>
      </div>

      <div className="color-8F8F8F font-semibold font-size-12px">
        {selectedImage
          ? "Click or Drag to Replace Image"
          : "Supported formats: JPG, PNG"}
      </div>
    </div>
  );
};

export default EventEHRUploadImageCard;
